<template>
  <div>
    <v-container fluid class="pa-0">
      <v-card class="v-card--material pa-3 ma-2 rounded-lg" elevation="2">
        <v-row no-gutters>
          <v-col cols="12" lg="2" class="my-0 py-0">
            <div class="d-flex grow flex-wrap">
              <div class="ml-2">
                <div class="font-weight-regular headline text-decoration-underline text-capitalize">
                  SOP Home
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-card-actions>
          <a @click="$router.back()">
            <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top> <v-icon left>mdi-arrow-left</v-icon>back </v-btn>
            <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1" class="mr-n2 mt-10" style="opacity:.6;">
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
          </a>
        </v-card-actions>
        <v-dialog
          v-model="editModal"
          persistent
          width="500"
          :active="editModal"
          :on-cancel="
            () => {
              editModal = false
            }
          "
        >
          <form action="modal-card-body" @submit.prevent="editFolder">
            <v-card>
              <v-toolbar dark color="darkblue">
                <v-toolbar-title
                  >Edit folder :<i>{{ oldName }}</i></v-toolbar-title
                >
              </v-toolbar>
              <v-card-text>
                <label class="label">Name</label>
                <v-text-field label="Enter valid character"> </v-text-field>
              </v-card-text>
              <v-col cols="12" md="12">
                <label class="font-weight-medium body-2">Access Level</label>
                <multiselect
                  class="overflowmultiselect2"
                  label="role"
                  track-by="role"
                  @input="checkTicketAdmin(selectedRoles)"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :preserve-search="true"
                  :preselect-first="false"
                  :multiple="true"
                  :options="roles"
                  v-model="selectedRoles"
                  ><template slot="selection" slot-scope="{ values, isOpen }"
                    ><span class="multiselect__single" v-if="values.role && !isOpen">{{ values.role }} </span></template
                  >
                </multiselect>
              </v-col>

              <v-card-actions class="justify-end">
                <v-btn class="button" @click="editModal = false">Cancel</v-btn>
                <span class="v-btn__content"><input type="submit" class="button" value="Save"/></span>
              </v-card-actions>
            </v-card>
          </form>
        </v-dialog>
        <v-dialog
          v-model="addModalOk"
          :width="isUpload ? '500px' : '500px'"
          :active="addModalOk"
          :on-cancel="
            () => {
              ;(addModalOk = false), (folderName = ''), (selectedClassID = ''), (dropFile = [])
            }
          "
        >
          <div v-if="isUpload">
            <form action="modal-card-body">
              <v-card width="500px">
                <v-card-text>
                  <v-row>
                    <v-col cols="12">
                      <label class="label">
                        {{ inputTitle }}
                        <span class="require has-text-danger">*</span>
                      </label>
                      <span class="has-text-danger">Allowed file's: .pdf, .doc, .docx, .docm, .xlsx, .xlsb, .xlsm, .xls, .pptx, .ppt, .pps</span>
                      <span class="has-text-danger">Max file size: 50MB each</span>
                      <span class="has-text-danger">File's that are not supported will be removed automatically!</span>
                    </v-col>
                    <v-col cols="12">
                      <v-file-input label="Click to upload" clear-icon="mdi-close" multiple required outlined placeholder="Click to upload" v-model="dropFile" @input="onFilechange()"></v-file-input>
                      <span v-if="dropFile.length > 0">
                        <div class="tags">
                          <span class="tag is-primary" v-for="(file, i) in dropFile" :key="i">
                            {{ file.name }} <button class="delete is-small" type="button" @click="deleteDropFile(i)"></button>
                          </span>
                        </div>
                      </span>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions class="justify-end">
                  <v-btn
                    @click="
                      () => {
                        ;(addModalOk = false), (dropFile = [])
                      }
                    "
                  >
                    Close
                  </v-btn>
                  <v-btn color="primary" @click="uploadNow">Upload</v-btn>
                </v-card-actions>
              </v-card>
            </form>
          </div>
          <div v-else>
            <form action="modal-card-body" @submit.prevent="addFolder">
              <v-card>
                <v-card-text>
                  <div class="field pb-0 mb-0" v-if="isMain">
                    <label class="font-weight-medium body-2">
                      Roles
                      <span class="require error--text">*</span>
                    </label>
                    <multiselect
                      class="overflowmultiselect2"
                      label="roleName"
                      track-by="roleName"
                      @input="selectedRoles"
                      :close-on-select="false"
                      :clear-on-select="false"
                      :preserve-search="true"
                      :preselect-first="false"
                      :multiple="true"
                      :options="roles"
                      v-model="selectedRoles"
                      ><template slot="selection" slot-scope="{ values, isOpen }"
                        ><span class="multiselect__single" v-if="values.role && !isOpen">{{ values.roleName }} </span></template
                      >
                    </multiselect>
                  </div>
                  <label class="label pb-0 mb-0">Folder Name</label>
                  <v-text-field outlined v-model.trim="folderName" class="pa-2" label="New folder name" required> </v-text-field>
                </v-card-text>
                <v-card-actions class="justify-end">
                  <v-btn
                    @click="
                      () => {
                        ;(addModalOk = false), (folderName = ''), (sopAccessID = '')
                      }
                    "
                  >
                    Close</v-btn
                  >
                  <span class="v-btn__content"><input type="submit" class="button primary" value="Create"/></span>
                </v-card-actions>
              </v-card>
            </form>
          </div>
        </v-dialog>
        <!-- <section> -->
        <card-component>
          <div class="level">
            <div class="level-left" v-if="!isFolderId">
              <div class="level-item">
                <p class="subtitle">Section Lists</p>
              </div>
            </div>
            <!-- <div v-if="!isFolderId" class="level-right">
              <div class="level-item">
                <v-btn @click="modalOpen" color="primary" small right title="Add New Folder">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </div>
            </div> -->
          </div>
          <hr />

          <v-row v-if="folderList.length > 0">
            <v-col v-for="(folder, index) in folderList" :key="index" cols="12" lg="2">
              <v-card color="orange" class="rounded-lg mx-auto pl-1" elevation="2" @click="routerRedirect(folder)">
                <div class="d-flex flex-no-wrap justify-space-between fixed-height" style="background-color:white;">
                  <div>
                    <v-card-title class="text-h5 black--text">
                      <span>
                        <v-icon color="gray" x-large>mdi-folder-outline</v-icon>
                      </span>

                      <v-menu bottom left>
                        <template v-slot:activator="{}"> </template>
                        <v-list>
                          <!-- <v-list-item link>
                            <v-list-item-title v-if="modules.editFolder" aria-role="listitem" @click="edit(folder.folderId, folder.name)">Edit </v-list-item-title>
                          </v-list-item> -->
                        </v-list>
                      </v-menu>
                    </v-card-title>
                    <v-card-subtitle>
                      <div class="shortFoldername">{{ folder.name }}</div>
                    </v-card-subtitle>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>
          <p v-if="!isFolderId && folderList.length === 0">No folders here!!</p>
          <hr />
          <div class="level" v-if="!isMain">
            <div class="level-left">
              <div class="level-item">
                <p class="subtitle" v-if="!isFolderId">Files</p>
              </div>
            </div>
          </div>
          <div>
            <div class="">
              <div class="d-flex list-folder-items">
                <div v-for="file in files" :key="file.id" class="fileItems">
                  <div class="filesList">
                    <!-- directly calling the file path -->
                    <a :href="isWrite ? file.filePath : ''" target="_blank" v-if="isWrite">
                      <v-icon>mdi-file-document-multiple-outline</v-icon> {{ file.fileName }} &nbsp; &nbsp; &nbsp;
                      <span class="pl-8">
                        <v-icon title="Download"> mdi-download</v-icon>
                      </span>
                    </a>
                    <!-- view button for preview only for other users -->
                    <a v-on:click="openPopup(file)" v-if="!isWrite">
                      <v-icon>mdi-file-document-multiple-outline</v-icon> {{ file.fileName }} &nbsp; &nbsp; &nbsp;
                      <span class="pl-8">
                        <v-icon> mdi-eye</v-icon>
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr v-if="!isMain" />
        </card-component>
      </v-card>
      <v-dialog
        persistent
        v-model="pdfViewModal"
        :active="pdfViewModal"
        :on-cancel="
          () => {
            pdfViewModal = false
          }
        "
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card class="height-auto">
          <v-toolbar dark color="accent">
            <v-toolbar-title> Pdf View</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn icon dark @click="pdfViewModal = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text>
            <pdfCanvas :url="pdfViewSrc" v-if="pdfViewModal"></pdfCanvas>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <loading-icon :value="isLoading" />
    </v-container>
  </div>
</template>
<script>
import CardComponent from '@/components/template/CardComponent'
import constants from '@/utils/constants'
import Multiselect from 'vue-multiselect'
import { mapGetters } from 'vuex'
import Utils from '@/utils'
import pdfCanvas from './pdf-canvas.vue'

export default {
  name: 'sopHome',
  components: {
    CardComponent,
    Multiselect,
    pdfCanvas
  },
  props: ['sopAccessID', 'folderId'],
  data () {
    return {
      modules: {
        editFolder: this.checkModuleAccess('editFolder')
      },
      selectedID: '',
      selectedRoles: [],
      roles: [],
      getList: [],
      isLoading: false,
      addModalOk: false,
      name: '',
      folderName: '',
      foldersArr: [],
      folderList: [],
      isMain: true,
      isFolderId: false,
      parentFolderId: '',
      isUpload: false,
      fileName: '',
      dropFile: [],
      inputTitle: "Select file('s)",
      editModal: false,
      newName: '',
      oldName: '',
      renameId: '',
      idForUpload: '',
      files: [],
      loadingComponent: null,
      isWrite: false,
      pdfViewModal: false,
      pdfViewSrc: '',
      allowedFiles: ['pdf', 'doc', 'docx', 'docm', 'xlsx', 'xlsb', 'xlsm', 'xls', 'pptx', 'ppt', 'pps']
    }
  },
  created: async function () {
    await this.getRoleList()
    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
    this.getFolderList(this.folderId, 'fromWatch')
  },
  computed: {
    ...mapGetters({})
  },
  mounted: async function () {
    if (this.folderId) {
      this.isFolderId = true
    }
    // this.getFolderList(this.sopAccessID, 'fromWatch')
  },
  watch: {
    folderId (val) {
      this.files = []
      // this.foldersArr = []
      this.getFolderList(val, 'fromWatch')
    },
    $route (to, from) {
      if (this.folderId) {
        this.isFolderId = true
        location.reload()
      }
    }
  },
  methods: {
    addFolder: async function () {
      let formData = {
        name: '',
        isActive: true,
        accessibleTo: this.selectedRoles.map(item => {
          return {
            sopAccessID: item.id
          }
        })
      }

      if (!this.folderName) {
        this.errMsg('Folder name cannot be empty!')
        return false
      }
      if (this.folderName !== '') {
        formData.name = this.folderName
      }

      if (this.isMain) {
      } else if (this.parentFolderId) {
        formData.folderMapID = this.parentFolderId
      }
      try {
        this.loadingComponent = this.$buefy.loading.open()
        let res = await http.post(`${constants.API_URL}/api/sop-module/createfolder`, formData)
        if (res.data === 'Folder Already Exist.') {
          this.errMsg(res.data)
        } else {
          this.okMsg(res.data)
        }
        this.addModalOk = false
        this.folderName = ''
        this.loadingComponent.close()

        this.getFolderList(this.parentFolderId ? this.parentFolderId : null, 'fromWatch')
      } catch (e) {
        this.loadingComponent.close()

        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },

    getRoleList: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/sop-module/allroles`)
        this.roles = data.rows
        this.isLoading = false

        return this.roles
      } catch (e) {
        this.isLoading = false

        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While fetching role', errorMessage)
        this.lock = false
        this.hasClicked = false
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      }
    },
    routerRedirect: async function (folder) {
      this.$router.push({ name: 'sopFolder', params: { folderId: folder.id } })
    },
    getFolderList: async function (folderId = null) {
      let url = ''
      try {
        this.isLoading = true
        let response = null
        if (folderId) {
          url = `${constants.API_URL}/api/sop-module/folder/${folderId}`
          response = await http.get(url)
          this.files = response.data.files
          // console.log(this.files, 'testing3')
          this.isMain = !folderId
        } else {
          url = `${constants.API_URL}/api/sop-module/allsops`
          response = await http.get(url)
          this.folderList = response.data.rows
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While folder listing', errorMessage)
        this.lock = false
        this.hasClicked = false
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      } finally {
        this.isLoading = false
      }
    },

    checkModuleAccess: function (moduleName) {
      return Utils.helper.checkAccessByModule(this.$route, moduleName)
    },

    editFolder: async function () {
      if (!this.newName) {
        this.errMsg('Name cannot be empty!')
        return false
      }
      try {
        await http.post(`${constants.API_URL}/api/folder/rename/${this.renameId}`, {
          name: this.newName,
          academicYearID: this.academicYearID
        })
        this.okMsg('Folder Renamed!!')
        this.editModal = false
        this.newName = ''
        this.getFolder(this.folderId, 'fromWatch')
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    edit (id, name) {
      this.editModal = true
      this.renameId = id
      this.oldName = name
    },

    modalOpen (mode) {
      this.addModalOk = true
      this.isUpload = mode === 'upload'
    },
    openPopup: function (file) {
      if (file.fileType === 'pdf') {
        this.pdfViewSrc = file.filePath
        this.pdfViewModal = true
      } else {
        this.errMsg('File Type Not Supported !')
      }
    },
    okMsg (msg) {
      return this.$dialog.info({
        text: msg,
        title: 'Success'
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>
<style scoped>
.tile.is-child {
  border: 1px solid #ff000059;
}
.fol-name {
  overflow-wrap: break-word;
}
.folder {
  cursor: pointer;
}
.is-justify-content-space-between {
  justify-content: space-between;
}

.shortFoldername div {
  padding: 0 20px;
}
.v-list-item .editItem {
  display: block;
}
.filesList {
  width: 100%;
  margin: 15px;
}
.filesList a i {
  font-size: 30px;
}
.fileItems {
  width: 50%;
}
.list-folder-items {
  width: 100%;
  align-content: space-between;
  flex-wrap: wrap;
}
@media (min-width: 375px) and (max-width: 477px) {
  .v-btn--absolute.v-btn--right.v-btn--top {
    margin-top: 0px !important;
  }
}
@media screen and (min-width: 800px) {
  .fixed-height {
    height: 100px;
  }
  .shortFoldername {
    width: 155px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .shortFoldername:hover {
    background: #eaeaea;
    border: 1px solid #ccc;
    position: relative;
    z-index: 9;
    left: 0;
    white-space: initial;
    min-height: 50px;
    min-width: 100px;
    padding: 5px;
    border-radius: 4px;
  }
}
@media screen and (max-width: 600px) {
  .shortFoldername {
    display: block;
    position: relative;
    word-break: break-all;
  }
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
